<template>
    <div class="pos-relative d-inline-block">
        <v-overlay absolute :value="isLoading">
          <v-progress-circular
              indeterminate
              size="24"
          />
        </v-overlay>
        <v-img :src="src" width="90px" height="90px" class="radius-root"/>
        <CloseBtn @delete="photoDelete" v-if="showCloseBtn" />
    </div>
</template>
<script>
import CloseBtn from '@/components/btns/CloseBtn'
export default {
    props:{
        src: String,
        isLoading: Boolean,
        showCloseBtn:{
            type: Boolean,
            default: true
        }
    },
    components:{
        CloseBtn,
    },
    methods:{
        photoDelete(){
            this.$emit('photoDelete')
        }
    }
}
</script>
